<template>
  <div class="flex flex-col justify-between flex-grow min-h-0">
    <div class="px-8 py-4 h-full" v-bar>
      <intent-examples v-if="intent.id"
                       :intent-id="intent.id"
                       :bot-id="botId"
                       class="h-full"
      />
    </div>

    <div v-if="!isUnknownAnswer" class="w-full flex items-center pl-11 py-5 bg-white shadow-lg">
      <img :src="iconPath" :alt="isEnoughExamples ? 'checkmark icon' : 'alert icon'">
      <span class="ml-3 text-gray-dark w-8/12" data-cy="examples-counter">
        {{ readyForProductionStatusText }}
      </span>
    </div>
  </div>
</template>

<script>
import alertTriangleIcon from '@/assets/images/icons/alert_triangle.svg'
import checkCircleIcon from '@/assets/images/icons/check_circle.svg'
import IntentExamples from './IntentExamples'
import answerModule from '@/store/modules/answer.module'
import { MIN_EXAMPLES } from '@/store/constants'
import editorUtils from '@/utils/editor.utils'

export default {
  name: 'IntentExamplesSidebar',
  components: { IntentExamples },
  props: {
    botId: {
      type: String,
      required: true
    }
  },

  computed: {
    answer: answerModule.getAnswer,
    answerExamplesCount: answerModule.getAnswerExamplesCount,

    iconPath() {
      return this.isEnoughExamples ? checkCircleIcon : alertTriangleIcon
    },

    intent() {
      return this.answer.intent
    },

    readyForProductionStatusText() {
      const additionalExamplesRequired = MIN_EXAMPLES - this.answerExamplesCount
      return this.isEnoughExamples ? 'Answer can be published!' :
        `${additionalExamplesRequired} more ${additionalExamplesRequired === 1 ?
          'example' : 'examples'} required to enable publish answer toggle.`
    },

    isEnoughExamples() {
      return this.answerExamplesCount >= MIN_EXAMPLES
    },

    isUnknownAnswer() {
      return editorUtils.isUnknownAnswer(this.intent.platformId)
    }
  }
}
</script>
